
    import { defineComponent } from 'vue'
    import Icon from '@/components/Icon/IndexIcon.vue'

    export default defineComponent({
        components: {
            Icon
        }
    })
